import { getPermissionsMap } from 'src/utils/helpers';
import { Permissions } from 'src/utils/enums/permissions.enum';
import { useMemo } from 'react';

// Mirrors deleteDistributionRule in de-portal-be-extended-api.
const DELETE_RULE_PERMISSIONS = [
    Permissions.NEWS_STORY_MANAGEMENT,
    Permissions.MARKETING_BULLETINS,
    Permissions.DISTRIBUTION_RULE_MANAGEMENT,
];

export const useDistributionRulePermissions = () => {
    const permissionsMap = useMemo(() => getPermissionsMap(), []);

    return {
        // saveDistributionRule only accepts DistributionRuleManagement.
        canEditRules: permissionsMap.has(
            Permissions.DISTRIBUTION_RULE_MANAGEMENT,
        ),
        canDeleteRules: DELETE_RULE_PERMISSIONS.some((permission) =>
            permissionsMap.has(permission),
        ),
    };
};
